import { createFileRoute } from "@tanstack/react-router";
import { sciHead } from "@/lib/science/sci-route";
import { m } from "@/paraglide/messages";
import { CalculatorPage } from "@/tools/od260/pages/CalculatorPage";

export const Route = createFileRoute("/od260-concentration")({
  ssr: true,
  head: () =>
    sciHead({
      basePath: "/od260-concentration",
      title: m.od_meta_title(),
      description: m.od_meta_description(),
      toolName: m.od_tool_name(),
      faqs: [
        { q: m.od_faq_q1(), a: m.od_faq_a1() },
        { q: m.od_faq_q2(), a: m.od_faq_a2() },
        { q: m.od_faq_q3(), a: m.od_faq_a3() },
        { q: m.od_faq_q4(), a: m.od_faq_a4() },
      ],
    }),
  component: CalculatorPage,
});
